export const styles = {
  table: {
    background: '#FAFAFA',
    padding: 10,
  },
};
